import Button from '@berlitz/button'
import styled, { css } from 'styled-components'

export const Pill = styled(Button)<{
  success?: boolean
  warning?: boolean
  spaceRight?: boolean
  empty?: boolean
}>`
  padding: ${({ theme }) => `0 ${theme.space.xs}`};
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  height: ${({ theme }) => theme.layout.xs};
  vertical-align: middle;

  svg {
    color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  }

  margin-right: ${({ theme, spaceRight }) => (spaceRight ? theme.space.sm : 0)};
  margin-top: ${({ theme }) => theme.space.xxxs};
  margin-bottom: ${({ theme }) => theme.space.xxxs};

  ${({ theme, success }) =>
    success &&
    css`
      background: ${theme.palette.success100};
      svg {
        font-size: ${theme.fontSize.xs};
        margin: 0 -5px 0 -4px;
      }
      &:hover {
        background: ${theme.palette.success100};
      }
    `};

  ${({ theme, warning }) =>
    warning &&
    css`
        padding: 5px ${theme.space.sm};
        background: ${theme.palette.warning100};
        svg {
          font-size: ${theme.fontSize.xxs};
          margin: 0 -7px};
        }
        &:hover {
          background: ${theme.palette.warning100};
        }
      `};

  ${({ theme, warning, success }) =>
    !warning &&
    !success &&
    css`
      background: ${theme.palette.danger100};
      svg {
        font-size: ${theme.fontSize.md};
        margin: 0 -7px};
      }
      &:hover {
        background: ${theme.palette.danger100};
      }
    `};

  ${({ empty }) =>
    empty &&
    css`
      visibility: hidden;
    `};
`
